import { Enumerable } from '../shared/linq';
import type { IGame } from '../shared/interfaces/IGame';
import type { ITeam } from '../shared/interfaces/ITeam';
import type { IWeek } from '../shared/interfaces/IWeek';

type BracketPlayoffTeams = Record<string, Record<string, ITeam[]>>;

export const playoffTeams: BracketPlayoffTeams = {
  '4': {},
  '3': {},
  '2': {},
  '1': {},
  '0': {},
};

export let nameLength: number;
export let bracketHeight: number;
export let iterations = 4;
export let skip = -1;
export let useByeWeek = true;
export let forkCount = 0;
export let debugMode = false;
export let bracketScale = 1.5;
export let redrawChopped = false;
export let postSeasonVersion = 1;

export function OrderGames(games: KnockoutObservable<IGame>[]): KnockoutObservable<IGame>[] {
  return Enumerable.From(games)
    .OrderByDescending((p: any) => p().TeamThatWon()().ConferenceRank())
    .ToArray();
}

export function GenerateBracket(
  wc: IWeek[],
  dv: IWeek[],
  cg: IWeek[],
  sb: IWeek[],
  requestedVersion: number
): boolean {
  if (!(wc && dv && cg && sb)) return false;
  postSeasonVersion = requestedVersion;
  if (requestedVersion == 1) {
    bracketHeight = 30;
  } else {
    bracketHeight = 46;
  }
  const bracketsEl = document.getElementById('brackets');
  if (bracketsEl) bracketsEl.innerHTML = '';
  if (
    postSeasonVersion == 1 &&
    wc[0].GamesComputed().length == 2 &&
    wc[2].GamesComputed().length == 2 &&
    dv[0].GamesComputed().length == 2 &&
    dv[2].GamesComputed().length == 2 &&
    cg[0].GamesComputed().length == 1 &&
    cg[2].GamesComputed().length == 1 &&
    sb[1].GamesComputed().length == 1 &&
    sb[1].GamesComputed()[0]().selectionMade()
  ) {
    forkCount = 0;
    var afcwcordered: any[] = OrderGames(wc[0].GamesComputed());
    var nfcwcordered: any[] = OrderGames(wc[2].GamesComputed());
    playoffTeams['0']['0'] = [sb[1].GamesComputed()[0]().TeamThatWon()()]; //winner
    playoffTeams['4']['0'] = [
      cg[0].GamesComputed()[0]().TeamThatWon()(),
      cg[2].GamesComputed()[0]().TeamThatWon()(),
    ]; //sb
    playoffTeams['3']['1'] = [
      dv[0].GamesComputed()[1]().TeamThatWon()(),
      dv[0].GamesComputed()[0]().TeamThatWon()(),
    ]; //afccg
    playoffTeams['3']['20'] = [
      dv[2].GamesComputed()[1]().TeamThatWon()(),
      dv[2].GamesComputed()[0]().TeamThatWon()(),
    ]; //nfccg

    playoffTeams['2']['21'] = [dv[2].GamesComputed()[1]().home(), dv[2].GamesComputed()[1]().away()]; //nfcdv2
    playoffTeams['2']['30'] = [dv[2].GamesComputed()[0]().home(), dv[2].GamesComputed()[0]().away()]; //nfcdv1

    playoffTeams['2']['2'] = [dv[0].GamesComputed()[1]().home(), dv[0].GamesComputed()[1]().away()]; //afcdv2
    playoffTeams['2']['11'] = [dv[0].GamesComputed()[0]().home(), dv[0].GamesComputed()[0]().away()]; //afcdv1

    //afc wc
    playoffTeams['1']['4'] = [afcwcordered[0]().TeamThatWon()(), afcwcordered[0]().TeamThatLost()()]; //6@3
    playoffTeams['1']['13'] = [afcwcordered[1]().away(), afcwcordered[1]().home()]; //5@4

    //nfc wc
    playoffTeams['1']['23'] = [nfcwcordered[0]().TeamThatWon()(), nfcwcordered[0]().TeamThatLost()()]; //6@3
    playoffTeams['1']['32'] = [nfcwcordered[1]().TeamThatWon()(), nfcwcordered[1]().TeamThatLost()()]; //5@4
    RenderBrackets();
    return true;
  } else if (
    postSeasonVersion == 2 &&
    wc[0].GamesComputed().length == 3 &&
    wc[2].GamesComputed().length == 3 &&
    dv[0].GamesComputed().length == 2 &&
    dv[2].GamesComputed().length == 2 &&
    cg[0].GamesComputed().length == 1 &&
    cg[2].GamesComputed().length == 1 &&
    sb[1].GamesComputed().length == 1 &&
    sb[1].GamesComputed()[0]().selectionMade()
  ) {
    forkCount = 0;
    var afcwcordered: any[] = OrderGames(wc[0].GamesComputed());
    var nfcwcordered: any[] = OrderGames(wc[2].GamesComputed());
    playoffTeams['0']['0'] = [sb[1].GamesComputed()[0]().TeamThatWon()()]; //winner
    playoffTeams['4']['0'] = [
      cg[0].GamesComputed()[0]().TeamThatWon()(),
      cg[2].GamesComputed()[0]().TeamThatWon()(),
    ]; //sb
    playoffTeams['3']['1'] = [
      dv[0].GamesComputed()[1]().TeamThatWon()(),
      dv[0].GamesComputed()[0]().TeamThatWon()(),
    ]; //afccg
    playoffTeams['3']['26'] = [
      dv[2].GamesComputed()[0]().TeamThatWon()(),
      dv[2].GamesComputed()[1]().TeamThatWon()(),
    ]; //nfccg

    playoffTeams['2']['2'] = [dv[0].GamesComputed()[1]().home(), dv[0].GamesComputed()[1]().away()]; //afcdv2
    playoffTeams['2']['11'] = [dv[0].GamesComputed()[0]().home(), dv[0].GamesComputed()[0]().away()]; //afcdv 1

    playoffTeams['2']['42'] = [dv[2].GamesComputed()[1]().away(), dv[2].GamesComputed()[1]().home()]; //nfcdv2
    playoffTeams['2']['27'] = [dv[2].GamesComputed()[0]().home(), dv[2].GamesComputed()[0]().away()]; //nfcdv1

    //afc wc
    playoffTeams['1']['4'] = [afcwcordered[0]().TeamThatWon()(), afcwcordered[0]().TeamThatLost()()];
    playoffTeams['1']['19'] = [afcwcordered[1]().away(), afcwcordered[1]().home()];
    playoffTeams['1']['12'] = [afcwcordered[2]().away(), afcwcordered[2]().home()];

    //nfc wc
    playoffTeams['1']['43'] = [nfcwcordered[0]().TeamThatWon()(), nfcwcordered[0]().TeamThatLost()()]; //6@3
    playoffTeams['1']['35'] = [nfcwcordered[1]().TeamThatWon()(), nfcwcordered[1]().TeamThatLost()()]; //5@4
    playoffTeams['1']['28'] = [nfcwcordered[2]().away(), nfcwcordered[2]().home()]; //7@2
    RenderBrackets();
    return true;
  } else {
    const el = document.getElementById('brackets');
    if (el) el.innerHTML = '';
  }
  return false;
}

export function RenderBrackets(): void {
  const brackets = document.getElementById('brackets');
  if (!brackets) return;
  brackets.innerHTML = '';
  const parentWidth = (brackets.parentElement as HTMLElement).offsetWidth;
  brackets.style.width = parentWidth + 'px';

  var canvas: HTMLCanvasElement = document.createElement('canvas');
  canvas.width = parentWidth;
  if (postSeasonVersion == 1) {
    canvas.height = 548;
  } else {
    canvas.height = 700;
  }
  var ctx = canvas.getContext('2d');
  ctx.translate(0.5, 0.5);
  //This is how long our name lines are allowed to be
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  nameLength = Math.floor(canvas.width / (iterations + 1));
  ctx.fillStyle = 'black';
  ctx.font = '14px helvetica ';
  ctx.strokeStyle = 'black';
  ctx.lineWidth = 1;
  var x = canvas.width,
    y = canvas.height / 2 + 3;
  drawWinner(ctx, x, y);
  if (postSeasonVersion == 1) {
    forkV1(ctx, x - nameLength, y, iterations, bracketHeight);
  } else if (postSeasonVersion == 2) {
    forkV2(ctx, x - nameLength, y, iterations, bracketHeight);
  }
  waterMark(ctx, canvas.width, canvas.height);
  brackets.style.display = '';
  brackets.appendChild(canvas);
  const uploadLink = document.createElement('a');
  uploadLink.href = 'javascript:void(0)';
  uploadLink.id = 'bracketUpload';
  uploadLink.className = 'pull-right btn btn-primary';
  uploadLink.innerHTML = '<i class="fa fa-cloud-upload"></i> Upload Bracket';
  brackets.appendChild(uploadLink);
}

export function drawWinner(ctx: CanvasRenderingContext2D, x: number, y: number): void {
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x - nameLength, y);
  writeTeam(ctx, x - nameLength, y - 5, 0, 0, 0);
  ctx.stroke();
  ctx.closePath();
}

export function forkV1(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  iteration: number,
  height: number
): void {
  var localCount = forkCount;
  forkCount++;
  var topOffset = y - height * iteration;
  if (iteration == 1 && useByeWeek) {
    skip++;
  }

  if (
    (iteration == 1 && skip % 2 == 0 && useByeWeek) ||
    x < 0 ||
    topOffset < 0 ||
    iteration < 0
  ) {
    return;
  }
  //top prong
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, topOffset);
  ctx.lineTo(x - nameLength, topOffset);
  ctx.stroke();
  writeTeam(ctx, x - nameLength, topOffset - 5, iteration, localCount, 0);
  ctx.closePath();
  forkV1(ctx, x - nameLength, topOffset, iteration - 1, height / bracketScale);

  //bottom prong
  var bottomOffset;
  bottomOffset = y + height * iteration;

  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, bottomOffset);
  ctx.lineTo(x - nameLength, bottomOffset);
  ctx.stroke();
  writeTeam(ctx, x - nameLength, bottomOffset + 22, iteration, localCount, 1);
  ctx.closePath();
  forkV1(ctx, x - nameLength, bottomOffset, iteration - 1, height / bracketScale);
}

export function forkV2(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  iteration: number,
  height: number
): void {
  var localCount = forkCount;
  forkCount++;
  var topOffset = y - height * iteration;
  if (iteration == 1 && useByeWeek) {
    skip++;
  }

  if ((useByeWeek && localCount == 3) || localCount == 50 || x < 0 || topOffset < 0 || iteration < 0) {
    return;
  }
  //top prong
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, topOffset);
  ctx.lineTo(x - nameLength, topOffset);
  ctx.stroke();
  writeTeam(ctx, x - nameLength, topOffset - 5, iteration, localCount, 0);
  ctx.closePath();
  forkV2(ctx, x - nameLength, topOffset, iteration - 1, height / bracketScale);

  //bottom prong
  var bottomOffset;
  bottomOffset = y + height * iteration;

  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, bottomOffset);
  ctx.lineTo(x - nameLength, bottomOffset);
  ctx.stroke();
  writeTeam(ctx, x - nameLength, bottomOffset + 22, iteration, localCount, 1);
  ctx.closePath();
  forkV2(ctx, x - nameLength, bottomOffset, iteration - 1, height / bracketScale);
}

export function writeTeam(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  iteration: number,
  localCount: number,
  idx: number
): void {
  try {
    x += 5;
    const team = playoffTeams[iteration][localCount][idx] as ITeam;
    var originalFont = ctx.font;
    var teamWidth = ctx.measureText(team.TeamName).width;
    if (teamWidth + 50 < nameLength && !redrawChopped) {
      ctx.fillText(team.TeamName, x + 32, y);
      ctx.fillText(team.ConferenceRank().toString(), x + teamWidth + 32, y - 5);
    } else {
      if (!redrawChopped) {
        redrawChopped = true;
        RenderBrackets();
      }
      ctx.fillText(team.ConferenceRank().toString(), x + 32, y - 5);
    }
    ctx.font = '10px helvetica';

    ctx.font = originalFont;
    var logo = new Image();
    logo.src = '/content/nfl/svg/' + team.TeamAbbreviation + '.svg';
    logo.width = 32;
    logo.height = 32;
    logo.onload = () => {
      ctx.drawImage(logo, x, y - 25, logo.width, logo.height);
    };
  } catch (ex) {
    if (debugMode) {
      ctx.fillText(iteration + '-' + localCount, x, y);
    }
  }
}

export function waterMark(ctx: CanvasRenderingContext2D, x: number, y: number): void {
  measureAndWrite(ctx, x, y - 26, 'Created by Playoff Predictors');
  measureAndWrite(ctx, x, y - 12, 'https://PlayoffPredictors.com/');
  var logo = new Image();
  logo.src = '/content/playoff-predictor-color-02.svg';
  logo.width = 48;
  logo.height = 48;
  logo.onload = () => {
    ctx.drawImage(
      logo,
      x - ctx.measureText('https://PlayoffPredictors.com/').width - 48,
      y - 48,
      logo.width,
      logo.height
    );
  };
}

export function measureAndWrite(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  text: string
): void {
  var measurements = ctx.measureText(text);
  ctx.fillText(text, x - measurements.width, y);
}
